import { catchError, from, map, Observable, tap } from 'rxjs';
import { AxiosError, AxiosResponse } from 'axios';

import { sessionStore } from '@store/session/session.store';
import { CurrentUser } from '@store/session/session.model';
import { getCurrentUserDataSource } from '@store/session/session.requests';

import SnackError from '@utils/error.utils';
import APIAxios, { APIRoutes } from '@api/axios.api';
import { msalInstance } from '@config/azure.config';

export class SessionService {
  store = sessionStore;

  getCurrentUser = (): Observable<CurrentUser> => {
    return from(APIAxios(APIRoutes.GETMe()))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<CurrentUser>) => {
          return response.data;
        }),
        tap((user) => {
          this.store.update((state) => ({
              ...state,
              user,
            }),
            getCurrentUserDataSource.setSuccess(),
          );
        }),
        getCurrentUserDataSource.trackRequestStatus(),
      );
  };

  logout = () => {
    localStorage.clear();
    msalInstance.logoutRedirect().catch((e) => console.error(e));
  };
}

export const sessionService = new SessionService();
